import { getValidationRuleList } from "../../utils/validation/generateValidationRule";
import BaseDomainService from "./baseDomainServices";
import { ErrorMessage, SuccessMessage } from "../../utils/Messages";


const userDetail = {
  userId: 0,
  emailAddress: "",
  isActive: "",
  userName: "",
  password: "",
  confirmPassword: "",
  isActive: true,
  isAdmin: false,
  firstName: "",
  lastName: "",
  displayName: ""
};

export default class UserDomainServices extends BaseDomainService {
  // API Get
  getList = this.apiService.userServices.getUsersList;
  deleteUsers = this.apiService.userServices.deleteUsers;
  userAdd = this.apiService.userServices.addUsers;
  updateUser = this.apiService.userServices.updateUsers;
  getUserById = this.apiService.userServices.getUsersById;
  SettingService = this.apiService.setSystemConfigurationServices.getSystemConfiguration;
  setSettingService = this.apiService.setSystemConfigurationServices.setSystemConfiguration;


  //Table Grid columns
  gridColmns = [
    { name: "EmailAddress", title: "Email Address" },
    { name: "DisplayName", title: "Display Name" },
    { name: "IsActive", title: "Active" },
    { name: "Actions", title: "Actions" },
  ];

  // Define the state variables
  dataItem;
  moduleList;
  serverList = [];

  // define the form fields
  formFields = [
    {
      inputType: "text",
      tittle: "First Name",
      placeholder: "First Name",
      fieldName: "firstName",
      validation: [{ type: "require" }],
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "text",
      tittle: "Last Name",
      placeholder: "Last Name",
      fieldName: "lastName",
      validation: [{ type: "require" }],
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "password",
      tittle: "Password",
      placeholder: "Password",
      fieldName: "password",
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "password",
      tittle: "Confirm Password",
      placeholder: "Confirm Password",
      fieldName: "confirmPassword",
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "text",
      tittle: "Email Address",
      placeholder: "Email Address",
      fieldName: "emailAddress",
      validation: [{ type: "require" }],
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "checkbox",
      tittle: "Active",
      fieldName: "isActive",
      checked: true,
      display: 'flex',
      align: 'center',
      md: '12',
      lg: '3',
      xl: '3',
    },
    {
      inputType: "checkbox",
      tittle: "Admin",
      fieldName: "isAdmin",
      checked: true,
      display: 'flex',
      align: 'center',
      md: '12',
      lg: '3',
      xl: '3',
    }
  ];

  SettingformFields = [
    {
      inputType: "text",
      tittle: "Product Length",
      placeholder: "Product Length",
      fieldName: "productLength",
      validation: [{ type: "require" }],
      md: '12',
      lg: '6',
      xl: '6',
    },
    {
      inputType: "text",
      tittle: "Inquiry Prefix",
      placeholder: "Inquiry Prefix",
      fieldName: "inquiryPrefix",
      validation: [{ type: "require" }],
      md: '12',
      lg: '6',
      xl: '6',

    },
    {
      inputType: "checkbox",
      tittle: "Is Send Inquiry On Complete",
      fieldName: "isSendInquiryOnComplete",
      checked: true,
      className: 'm-auto pt-2',
      md: '12',
      lg: '6',
      xl: '6',
    },
  ];



  constructor() {
    super();
    this.onPaginationUpdate = this.onGetRequests.bind(this);
    this.actionKey = "Actions";
    this.actionActive = "isActive";
    this.dataItem = { ...userDetail };
  }

  //** API Calls

  onGetRequests = (requst) => {
    this.apiService.onAPICall("getRequest", this.getList, requst, this.onAPIResponse, this.onUpdateState);
  }
  onAddUser = (request) => {
    this.apiService.onAPICall("adduser", this.userAdd, request, this.onAPIResponse, this.onUpdateState);
  }
  onDeleteUsers = (requst) => {
    this.apiService.onAPICall("deleteUsers", this.deleteUsers, requst, this.onAPIResponse, this.onUpdateState);
  }
  onGetUserById = (requst) => {
    this.apiService.onAPICall("getUserById", this.getUserById, requst, this.onAPIResponse, this.onUpdateState);
  }
  OnGetSettingService = (requst) => {
    this.apiService.onAPICall("SettingService", this.SettingService, requst, this.onAPIResponse, this.onUpdateState);
  }
  OnsetSettingService = (requst) => {
    this.apiService.onAPICall("setSettingService", this.setSettingService, requst, this.onAPIResponse, this.onUpdateState);
  }
  onUpdateUser = (request) => {
    this.apiService.onAPICall("updateUser", this.updateUser, request, this.onAPIResponse, this.onUpdateState);
  }

  //** Service Event */

  onInitService() {
    //This method only call when we use form component and we can add all items which we on on form load
    let valRule = getValidationRuleList(this.formFields);
    this.validationRules = valRule;

    this.onUpdateState({
      validationRules: valRule,
      resetValidationRule: this.resetValidationRule,
    });
  }
  onInitServiceSetting() {
    let valRules = getValidationRuleList(this.SettingformFields);
    this.validationRules = valRules;
    this.onUpdateState({
      validationRules: valRules,
      resetValidationRule: this.resetValidationRule,
    });
  }

  onResetData = () => {
    this.dataItem = { ...userDetail };
    this.onUpdateState({ addRequestDetails: this.dataItem });
  };
  //** Methods     */
  //  When we get response from  API

  onRedirectoList = () => {
    this.onRedirect("/RequestHistoryList");
  };
  redirectToAdd = () => {
    this.onRedirect("/userDetail");
  };
  backToUserList() {
    this.onRedirect("/user");
  }

  onAPIResponse = (key, isSuccess, responseData) => {
    if (!isSuccess) {
      this.onUpdateState({ setIsLoad: false });
      return;
    }
    switch (key) {
      case "getRequest":
        if (responseData.itemList !== null) {
          this.onUpdateState({
            userList: responseData.itemList,
            totalCount: responseData.totalCount,
            setIsLoad: false,
            "btnLoading": false
          });
        }
        else {
          this.apiService.swalServices.Error(responseData.message);
        }
        break;

      case "adduser":
        if (responseData && responseData.errorType === "EXIST") {
          this.apiService.swalServices.Error(SuccessMessage.Already_Exist.replace("{0}", responseData.errorColumn));
        } else {
          this.apiService.swalServices.Toaster(SuccessMessage.Insert_Success.replace("{0}", "Product List"));
          this.backToUserList();
        }
        this.onUpdateState({ "setIsLoad": false, "btnLoading": false });
        break;
      case "SettingService":
        if (responseData.itemList !== null) {
          this.onUpdateState({
            settings: responseData,
            totalCount: responseData.totalCount,
            setIsLoad: false,
            "btnLoading": false
          });
        }
        else {
          // this.apiService.swalServices.Error(responseData.message);
        }
        break;

      case "setSettingService":
        if (responseData.errorType === "EXISTS") {
          this.apiService.serviceManager.swalServices.Alert(ErrorMessage.Already_Exist.replace("{0}", "User Already Exist"));
        }
        else {
          this.apiService.serviceManager.swalServices.Success(SuccessMessage.Update_Success.replace("{0}", "Settings"));
        }
        break;

      case "deleteUsers":
        if (responseData.hasError === false) {
          this.onGetRequests(this.pagination);
        }
        else {
          this.apiService.swalServices.Error(responseData.message);
        }
        this.onUpdateState({ setIsLoad: false, "btnLoading": false });
        break;

      case "updateUser":
        if (responseData && responseData.errorType === "EXIST") {
          this.apiService.swalServices.Error(SuccessMessage.Already_Exist.replace("{0}", responseData.errorColumn));
        } else {
          this.apiService.swalServices.Toaster(SuccessMessage.Update_Success.replace("{0}", "User"));
          this.backToUserList();
        }
        this.onUpdateState({ "setIsLoad": false, "btnLoading": false });
        break;

      case "getUserById":
        if (responseData !== null) {
          this.onUpdateState({
            userDetail: responseData,
            setIsLoad: false,
            isLoading: false,
            "btnLoading": false
          });
        }
        else {
          this.apiService.swalServices.Error(responseData.message);
        }
        break;
    }
  };
}
